import React, { useState } from 'react';
import theme from './BuyerOfferDocumentGroupCard.module.scss';
import { CardSection, ExpandableCard, ExpandableCardHandle } from '@/components/Cards';
import { DateDisplay } from '@/components/localization';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import { BuyerOfferDocumentGroup, BuyerOfferDocument } from '@/types';
import { BuyerOfferDocumentCard } from '../BuyerDocumentCard';
import { useIsMobile } from '@/utils/hooks';

interface BuyerOfferDocumentGroupCardProps {
    documentGroup: BuyerOfferDocumentGroup;
}

const InnerList: React.FC<{ documents: BuyerOfferDocument[] }> = ({ documents }) => {
    return (
        <div className={theme.expandList}>
            {documents.map((x) => (
                <BuyerOfferDocumentCard key={x.buyerOfferAttachmentId} document={x} onLinkClick={(e, doc) => null} />
            ))}
        </div>
    );
};

const BuyerOfferDocumentGroupCard: React.FC<BuyerOfferDocumentGroupCardProps> = ({ documentGroup }) => {
    const [expanded, setExpanded] = useState(false);
    const isMobile = useIsMobile();

    const fileIcon = <FontAwesomeIcon fixedWidth className={theme.fileIcon} icon={faFileInvoice} />;

    const content = (
        <>
            <div className={theme.label}>
                <div>{documentGroup.changeRequestSubject || <Trans>Offer #{documentGroup.name}</Trans>}</div>
                <small>{documentGroup.changeRequestId ? <Trans>Accepted change request offer</Trans> : <Trans>Offer</Trans>}</small>
            </div>

            <CardSection width="15%" caption={<Trans>Modified</Trans>}>
                <DateDisplay value={documentGroup.lastModified} />
            </CardSection>

            {/* <CardSection width="15%" caption={null}></CardSection> */}
        </>
    );

    return (
        <ExpandableCard
            containerClassName={theme.container}
            className={theme.card}
            expanded={expanded}
            expandableContent={<InnerList documents={documentGroup.documents} />}>
            {isMobile ? (
                <div className={theme.infoSection}>
                    {fileIcon}
                    <div className={theme.details}>{content}</div>
                </div>
            ) : (
                <>
                    {fileIcon}
                    {content}
                </>
            )}

            <ExpandableCardHandle expanded={expanded} onExpandToggle={setExpanded} />
        </ExpandableCard>
    );
};

export default BuyerOfferDocumentGroupCard;
